import { SearchbarFacet } from './searchbar-v2-facet';

export type SEARCHBAR_OPERATOR = keyof State;

export interface State {
    EQUAL: string | {value: string};
    NOT_EQUAL: string | {value: string};
    MATCH: string | {value: string};
    BIGGER_THAN: Date | number;
    BIGGER_OR_EQUAL_THAN: Date | number;
    SMALLER_THAN: Date | number;
    SMALLER_OR_EQUAL_THAN: Date | number;
    CONTAIN_ALL: Array<string | {value: string}>;
    CONTAIN_NOT_ALL: Array<string | {value: string}>;
    IS_ONE_OF: Array<string | {value: string}>;
    IS_NOT_ONE_OF: Array<string | {value: string}>;
    HAS: undefined;
    HAS_NOT: undefined;
}

export class SearchFilter {
    public alias?: string;
    public property: string;
    public operator: SEARCHBAR_OPERATOR;
    public value: State[SEARCHBAR_OPERATOR];
    public query: string;
    public chipLabel?: string;

    constructor(facet?: SearchbarFacet) {
        if (!facet) {
            return ;
        }
        this.property = facet.property;
        this.operator = facet.operators[0];
        this.value = facet.widget.options.defaultValue;
        this.alias = facet.alias;
    }
}
